const pkgVersion = require('../../../package.json').version

const seb = {
  appName: 'WebEAI',
  appCompany: 'Groupe SEB',
  env: process.env.NODE_ENV,
  isLoading: false,
  appVersion: pkgVersion,
  ldapDomains: [{ value: 'EU' }, { value: 'NA' }, { value: 'SA' }, { value: 'AS' }],
  loginType: [{ value: 'LDAP' }, { value: 'Application' }],
  environments: [
    { text: 'Flows.Environment.Development', value: 'dev' },
    { text: 'Flows.Environment.Staging', value: 'staging' },
    { text: 'Flows.Environment.Production', value: 'prod' }
  ],
  perPage: 20,
  pageEntries: [20, 30, 50],
  perPageLarge: 50,
  pageEntriesLarge: [50, 100, 500],
  pageEntriesLargeBis: [50, 100, 200],
  perPageExtraLarge: 100,
  pageEntriesExtraLarge: [100, 500, 1000],
  eventType: {
    maintenance: 'orange',
    incident: 'red',
    release: 'black'
  },
  chartOptions: {
    chart: {
      fontFamily: 'Montserrat',
      toolbar: { show: false }
    },
    title: {
      text: undefined,
      align: 'left',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: '14px',
        fontWeight: 'bold'
      }
    },
    tooltip: {},
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: new Array<string>()
    },
    fill: {
      opacity: 1
    }
  },
  apiRoutes: {
    event: {
      deleteEventAdmin: '/api/event/deleteEventAdmin?%s',
      deleteEvent: '/api/event/deleteEvent?%s',
      getEventsByMonth: '/api/Event/GetEventsByMonth?%s',
      getEventsByday: '/api/Event/GetEventsByDay?%s',
      GetEventsById: '/api/event/GetEventsById?%s',
      createOrUpdateEvent: '/api/Event/CreateOrUpdateEvent',
      GetTodayCountEvents: '/api/Event/GetTodayCountEvents?%s',
      GetFutureEvent: '/api/Event/GetEventInFuture'
    },
    dropdown: {
      getDropdown: '/api/dropdown/GetDropdown?%s',
      createOrUpdate: '/api/dropdown/createOrUpdate',
      delete: '/api/dropdown/delete?%s'
    },
    companycode: {
      getForSelectList: '/api/companycode/GetCompanyCode?%s',
      createOrUpdate: '/api/companycode/createOrUpdate',
      delete: '/api/companycode/delete?%s'
    },
    user: {
      getForSelectList: '/api/user/GetUsers?%s',
      getPaginated: '/api/user/GetUsersForManagement?%s',
      create: '/api/user/createOrUpdate',
      update: '/api/user/createOrUpdate'
    },
    company: {
      getForSelectList: '/api/company/GetCompanies?%s',
      getPaginated: '/api/company/GetCompaniesForManagement?%s',
      create: '/api/company/create',
      update: '/api/company/update',
      delete: '/api/company/Delete?businessCode=%s'
    },
    role: {
      getForSelectList: '/api/role/GetRoles?%s',
      getPaginated: '/api/role/GetRolesForManagement?%s',
      userConnectedRole: '/api/Role/GetRoleOfCurrentUser',
      create: '/api/role/create',
      update: '/api/role/update',
      delete: '/api/role/Delete?id=%s'
    },
    partner: {
      getForSelectList: '/api/partner/GetPartners?%s',
      getPaginated: '/api/partner/GetPartnersForManagement?%s',
      create: '/api/partner/create',
      update: '/api/partner/update',
      delete: '/api/partner/Delete?businessCode=%s'
    },
    contact: {
      getPaginated: '/api/contact/GetContactsForManagement?%s',
      create: '/api/contact/Create',
      update: '/api/contact/Update',
      delete: '/api/contact/Delete?id=%s'
    },
    filter: {
      create: '/api/Filter/CreateOrUpdate',
      update: '/api/Filter/CreateOrUpdate',
      get: '/api/Filter/GetMyFilter',
      delete: '/api/filter/DeleteFilter?id=%s'
    },
    flowList: {
      getHeader: '/api/FlowList/GetHeaderFlowList',
      getValues: '/api/FlowList/GetValuesFlowList?%s',
      importFile: '/api/FlowList/ImportDevFusionFile'
    }
  }
}

export default seb
